import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import ProjectStudentMap from "./routes/ProjectStudentMap";
import { routes } from "Projects/config/routes";
const {
  projectDetailsStep: { path },
} = routes;
const ProjectDetailsStep = store => {
  return {
    path,
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "project-group" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [ProjectStudentMap(store)],
  };
};
export default ProjectDetailsStep;
